import { ToastContext } from "../../toast.context";
import type { ToastProviderProps } from "./types-provider";
import { useToastProvider } from "./use-provider";
import { ToastProviderView } from "./view-provider";

/** Renderiza UM `Toast` do Prime e expõe `useToast()` aos filhos. */
export function ToastProvider({ children, ...options }: ToastProviderProps) {
  const { api, ...viewModel } = useToastProvider(options);

  return (
    <ToastContext.Provider value={api}>
      <ToastProviderView {...viewModel}>{children}</ToastProviderView>
    </ToastContext.Provider>
  );
}
ToastProvider.displayName = "ToastProvider";
